// Video kenalan 15 detik di halaman login (sumber: promo/murid/, file di public/video/).
// Diputar layar penuh lewat pemutar bersama (pemutar.js: orientasi, autoplay tanpa suara, cache).
//   - Pertama kali halaman login dibuka (dan online), video terbuka & diputar otomatis.
//   - Setelah pernah diputar, tidak otomatis lagi; bisa ditonton ulang lewat tombol.
// MP4 (H.264) didahulukan; WebM (VP9) untuk browser tanpa codec H.264.
import { MODE_DEMO } from './riwayat.js';
import { store } from '../core/storage.js';
import { bukaVideo } from './pemutar.js';

const VIDEO = { tegak: '/video/promo-tegak', lanskap: '/video/promo-lanskap' };
const KUNCI_DITONTON = 'tka-promo-ditonton';
let tombolPromo = null;

/** Tampilkan tombol "Tonton video" (tidak ada di versi demo satu-file). */
export function pasangPromo(tombol) {
  if (!tombol) return;
  tombolPromo = tombol;
  tombol.hidden = MODE_DEMO;
  if (!MODE_DEMO) tombol.onclick = () => bukaPromo(tombol);
}

/** Dipanggil saat halaman login tampil pertama kali: putar otomatis bila belum pernah ditonton. */
export function promoPertamaKali() {
  if (MODE_DEMO || store.get(KUNCI_DITONTON, 0) || navigator.onLine === false) return;
  if (document.querySelector('.promo-layar')) return;
  bukaPromo(tombolPromo, { otomatis: true });
}

function bukaPromo(asal, { otomatis = false } = {}) {
  bukaVideo({
    daftar: [VIDEO], webm: true,
    label: 'Video kenalan Kuis Juara TKA',
    akhir: { label: 'Ayo coba sekarang!', on: () => document.getElementById('in-name')?.focus() },
    saatMain: () => store.set(KUNCI_DITONTON, Date.now()),
    asal: otomatis ? null : asal,
  });
}
